/**
 * 文書をサーバーに置く `StoragePort`（索引 Issue #498 の段階 8）。**`duelEditor/timeline/` の外**。
 *
 * 置き場は replay 単位の timing のスロット（`OcgGetTiming` / `OcgSetTiming`）。**丸ごと置換**で、
 * 書くときは必ずプロジェクトファイル v4（`docs/duel-timing.md`）。読むときは v2 / v3 の古い文書も写して開ける
 * （`ocgDocument.js`）ので、**動かしたイベントの時刻を引き継いだまま**新しい画面に移れる。
 *
 * `load()` は同期の約束なので、`refresh()` で読んで表に持つ。
 * 保存できなかった理由は `status().error` に残す —— 編集は続けられたほうがよいので投げない。
 */
import { api } from '../api/api';
import { StoragePort } from '../duelEditor/timeline/ports/storage';
import { fromTiming, toTiming } from './ocgDocument';

export function createOcgStorage(replayId) {
  let doc = null;
  let savedAt = null;
  let error = null;
  let saving = false;
  const aux = new Map();

  const port = StoragePort.create({
    load: () => doc,
    save: (next) => save(next),
    loadAux: (key) => (aux.has(key) ? aux.get(key) : null),
    saveAux: (key, value) => { aux.set(key, value); },
    status: () => ({ saving, savedAt, error, dirty: false }),
  });

  async function refresh() {
    if (replayId == null) return doc;
    try {
      const res = await api.duel('OcgGetTiming', { replay_id: replayId });
      doc = fromTiming(res?.timing);
      error = null;
    } catch (e) {
      error = String(e?.message ?? e);
    }
    return doc;
  }

  async function save(next) {
    if (replayId == null) return false;
    saving = true;
    try {
      const res = await api.duel('OcgSetTiming', { replay_id: replayId, timing: toTiming(next) });
      if (res?.status !== 'success') throw new Error(res?.error ?? '保存できませんでした');
      doc = next;
      savedAt = Date.now();
      error = null;
      return true;
    } catch (e) {
      error = String(e?.message ?? e);
      return false;
    } finally {
      saving = false;
    }
  }

  return { ...port, refresh, get error() { return error; } };
}
